import { SearchEntityType } from '@newo/api/gateway';
import { ENTITY_TYPE_COLORS } from '@/components/SearchResultsContent/SearchResultsContent.constants.ts';

export const getTypeBadgeColor = (type: SearchEntityType): string => {
    return ENTITY_TYPE_COLORS[type] || 'gray';
};
